// extracted by mini-css-extract-plugin
module.exports = {"card-link__action":"card-link_card-link__action__e4Jos","card-link__content":"card-link_card-link__content___9uqR","card-link__image":"card-link_card-link__image__g9L4R"};